import { parse } from 'json2csv';

/**
 *
 * @param {string[]} columns
 * @param {Object[]} rows
 * @returns {Object} Object containing the name and size of the file created
 */
export const downloadTableData = (columns, rows) => {
  // TODO - make a more meaningful filename
  const fileName = 'MikMakDashboardReport.csv';

  const parseOpts = { fields: columns };
  const csv = parse(rows, parseOpts);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });

  downloadFile(blob, fileName);

  return {
    name: fileName,
    size: blob.size,
  };
};

export const downloadFile = (file, fileName) => {
  const url = URL.createObjectURL(file);

  const link = document.createElement('a');

  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const createBenchmarksFile = (columns, rows, name) => {

  const fileName = `MikMakBenchmarksInsights${name}.csv`;

  const parseOpts = { fields: columns };
  const csv = parse(rows, parseOpts);

  return {
    csv: csv,
    name: fileName,
  };
};

export const createAndDownloadBenchmarksFile = (columns, rows, name) => {

  const file = createBenchmarksFile(columns, rows, name);
  const blob = new Blob([file.csv], { type: 'text/csv;charset=utf-8;' });

  downloadFile(blob, file.name);

  return {
    name: file.name,
    size: blob.size,
  };
};
